// ─────────────────────────────────────────────────────────────────────────────
// board-config.service.ts
// Hoy devuelve configs del mock local.
// Cuando conectes Firebase, cambia getCodeConfig() / getDynamicConfig()
// para leer de Firestore — el resto del código NO cambia.
// ─────────────────────────────────────────────────────────────────────────────

import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { delay } from 'rxjs/operators';

import { BoardConfig, CodeBoardConfig } from './board-config.model';
import { CODE_BOARD_CONFIGS } from './mock-board-configs';
import { MOCK_BOARD_CONFIGS } from './mock-board-configs-legacy';

@Injectable({ providedIn: 'root' })
export class BoardConfigService {

  // ── Tableros tipo 'code' (componentes custom + tabs) ─────────────────────
  getCodeConfig(boardId: string): Observable<CodeBoardConfig> {
    const cfg = CODE_BOARD_CONFIGS[boardId];
    if (!cfg) return throwError(() => new Error(`CodeBoard "${boardId}" no encontrado`));
    return of(cfg).pipe(delay(0));

    // Firebase (descomentar cuando esté listo):
    // return this.firestore
    //   .doc<CodeBoardConfig>(`board_configs/${boardId}`)
    //   .valueChanges()
    //   .pipe(map(cfg => { if (!cfg) throw new Error('Not found'); return cfg; }));
  }

  // ── Tableros tipo 'dynamic' (solo charts/stats) ───────────────────────────
  getConfig(boardId: string): Observable<BoardConfig> {
    const cfg = MOCK_BOARD_CONFIGS[boardId];
    if (!cfg) return throwError(() => new Error(`DynamicBoard "${boardId}" no encontrado`));
    return of(cfg).pipe(delay(0));
  }
}
